import React, { Component } from "react";
import { connect } from "react-redux";
import "./GamePhaser.scss";
import { BootScene } from "./scene/boot";
import { PreloadScene } from "./scene/preload";
import { PlayScene } from "./scene/play";
import { setPointsGame, setUpdateTime, setStateGame } from "../../../state/actions/GameActions";
import { GameOverScene } from "./scene/gameOver";
import instrucciones from "./../../../assets/img/game/instrucciones.png";
import { updateStateGame } from "../../../state/actions/AccountActions";


 
class GamePhaser extends Component {
    
    public game: any = null ;
    config: GameConfig;
    timeLeft: number = 60;
    interval:any;
    state={
        instrucciones:true
    }
    constructor(props: any) {
        super(props);
        this.config = {
            type: Phaser.WEBGL,
            width: 603,
            height: 600,
            parent: "phaser-game",
            backgroundColor: "transparent",
            pixelArt: true
        };
        
    }
    componentDidMount() {
        const { handleChangePoints }: any = this.props;
        handleChangePoints(0);
        var aux: any = this.props;
        var ayuda = aux.Game.ayuda;
        this.timeLeft = 60;
        setTimeout(() => {
            this.setState({
                instrucciones:false
            })
            this.startTimer();
        }, 3500);
        this.game = new Phaser.Game(this.config);
        this.game.events.once("ready", () => {
            this.game.scene.add("BootScene", new BootScene());
            this.game.scene.add("PreloadScene", new PreloadScene()); 
            this.game.scene.add("PlayScene", new PlayScene(this.changePoints, ayuda)); 
            this.game.scene.add("GameOverScene", new GameOverScene()); 

            this.game.scene.start("BootScene");
        })
        
    }
    componentWillUnmount(){
        this.endGame();
        clearInterval(this.interval);
    }
    startTimer() {
        const { handleChangeTime }: any = this.props;
        this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
                handleChangeTime(this.timeLeft);
            } else {
                clearInterval(this.interval);
                this.endGame();
            }
        }, 1000);
    }
    endGame() {
        this.game.scene.start("GameOverScene");
        const { handleStateGame }: any = this.props;
        handleStateGame(false);
    }

    changePoints=(points:number)=>{
        const { handleChangePoints }: any = this.props;
        let aux: any = this.props;
        let puntos = aux.Game.puntosGame + points;
        if (puntos<0){
            puntos=0;
        }
        handleChangePoints(puntos);
    }
    render() {
        
        return (
            <div className="GamePhaser">
                <div id="phaser-game" />
                {this.state.instrucciones && <div className="instruccionGame"><img src={instrucciones} /></div>}
            </div>
        )
    }
}

const mapStateToProps = ({ Game, Account }: any) => ({ Game, Account });

const mapDispatchToProps = (dispatch:any) => ({
    handleChangePoints(size:number) {updateStateGame
        dispatch(setPointsGame(size));
    },
    handleChangeTime(time: number) {
        dispatch(setUpdateTime(time));
    },
    handleStateGame(state: boolean) {
        dispatch(setStateGame(state));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GamePhaser);
